import React from 'react';
import { IconAnonymousXL } from '../../icons';
import css from './AnonymCarouselPlaceholder.css';
import config from '../../config';

const { anonymRiderName, anonymousHorseName } = config;

const AnonymCarouselPlaceholder = ({ type, isAnonymousListing, children, assetElem }) =>
    isAnonymousListing ? (
        <>
            <div className={css.anonymCarouselWrapper}>
                <div className={css.anonymCarouselInnerBlock}>
                    <IconAnonymousXL rootClassName={css.anonymIcon} />
                    <p>
                        Du kannst Fotos und Videos von{' '}
                        {type === 'profile' ? anonymRiderName : anonymousHorseName} ansehen, sobald
                        deine Anfrage akzeptiert wurde.
                    </p>
                    {children}
                </div>
            </div>
            {assetElem}
        </>
    ) : (
        assetElem
    );

export default AnonymCarouselPlaceholder;
